import * as Buttons from "./Buttons"

export const basicOperators =
    [Buttons.DELETE,
     Buttons.PLUS,
     Buttons.MINUS,
     Buttons.MULTIPLE,
     Buttons.DIVIDE,
     Buttons.EQUAL]

export const extendedOperators =
    [Buttons.SQRT,
    Buttons.X2,
    Buttons.CLEAR,
    Buttons.REVERSE,
    Buttons.PERCENT,
    Buttons.ONEDIVIDEX]